<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Clientes</h1>
        </div>
        <div class="ctn_general">
            <div class="tabla_ctn">
                <div class="tabla_filtros">
                    <Filters :data="filterData" label="Filtrar clientes" @onFilter="onFilter"/>
                    <div class="tfiltros_col right mOrder1 nowrap">
                        <a @click="downloadExcel" href="javascript:void(0)"
                           class="descargar_archivo mdi mdi-arrow-collapse-down tool">
                            <span class="tooltip top left">Descargar Excel</span>
                        </a>
                        <div class="mdi mdi-magnify input_search">
                            <form @submit.prevent="search">
                                <input type="search"
                                       placeholder="Buscar cliente por nombre, apellido o correo electrónico"
                                       v-model="keyword">
                            </form>
                        </div>
                    </div>
                </div>
                <div class="tabla_scroll">
                    <table class="lPedidos">
                        <thead>
                        <tr>
                            <th>Nombres y Apellidos</th>
                            <th>Celular</th>
                            <th>D.N.I.</th>
                            <th>Referencia</th>
                            <th>Empresa</th>
                            <th>Descuento</th>
                            <th>Fecha de registro</th>
                            <th>Última compra</th>
                            <th>Nº Compras</th>
                            <th>Importe compras</th>
                            <th class="d_option"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="o in clients">
                            <td>{{o.fullName}}</td>
                            <td>{{o.phone}}</td>
                            <td style="text-align: center;">{{o.idCard}}</td>
                            <td style="text-align: center;">{{o.reference}}</td>
                            <td style="text-align: center;">{{o.company}}</td>
                            <td style="text-align: center;">{{o.disc}}<span v-if="o.disc">%</span></td>
                            <td style="text-align: center;" v-date-local="o.createdAt">{{o.createdAt}}</td>
                            <td style="text-align: center;" v-date-local="o.lastOrder">{{o.lastOrder}}</td>
                            <td style="text-align: center;">{{o.orders}}</td>
                            <td style="text-align: right;" v-pen="o.ordersAmount"></td>
                            <td class="d_option">
                                <i class="mdi mdi-dots-vertical"></i>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <Paginator :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
                           :changePageSize="changePageSize"/>
            </div>
        </div>
    </div>
</template>
<script>

    import ClientService from "../../services/ClientService";
    import {getFileName, loading} from '../../util/util'
    import fileDownload from 'js-file-download';
    import Paginator from '../common/Paginator.vue'
    import {paginatorMixin} from '../../util/paginatorMixin'
    import Filters from '../common/Filters.vue'
    import alert from '../../util/alert'

    export default {
        components: {Paginator, Filters},
        data() {
            return {
                clients: [],
                keyword: null,
                filterData: [
                    {
                        key: 'buyer',
                        label: 'Realizó compra',
                        type: 'single',
                        items: [{key: 1, value: 'Sí'}, {key: 0, value: 'No'}]
                    },
                ]
            }
        },
        mixins: [paginatorMixin],
        methods: {
            changePage(p) {
                const self = this;
                self.page = p;
                self.listClients(p, self.pageSize)
            },
            changePageSize(pageSize) {
                const self = this;
                this.page = 1;
                this.pageSize = pageSize;
                self.listClients(1, pageSize)
            },
            async listClients(page, pageSize) {
                try {
                    loading(true);
                    const self = this;
                    const params = {page: page - 1., size: pageSize};
                    if (self.keyword)
                        params.keyword = self.keyword;

                    if (self.filters && self.filters.length > 0) {
                        self.filters.forEach(it => {
                            let opts;
                            if (it.data instanceof Array) {
                                opts = [];
                                it.data.forEach(o => {
                                    opts.push(o.key);
                                })
                            } else {
                                opts = it.data.key;
                            }
                            params[it.key] = opts;
                        })
                    }

                    const resp = (await ClientService.list(params)).data.payload;
                    self.clients = resp.content;
                    self.total = resp.totalElements;
                    self.pages = resp.totalPages;
                } catch (err) {
                    alert.error(err);
                } finally {
                    loading(false);
                }
            },
            search() {
                const self = this;
                self.page = 1;
                self.listClients(self.page, self.pageSize);
            },
            reload() {
                const self = this;
                self.listClients(self.page, self.pageSize);
            },
            onFilter(data) {
                const self = this;
                self.filters = data;
                self.page = 1;
                self.listClients(self.page, self.pageSize);
            },
            downloadExcel() {
                loading(true);
                const params = {};
                const self = this;
                if (self.keyword)
                    params.keyword = self.keyword;

                ClientService.downloadExcel(params).then(response => {
                    fileDownload(response.data, getFileName(response));
                }).catch((err) => {
                    console.error(err);
                    alert.error("Error al descargar lista de clientes");
                }).finally(() => {
                    loading(false);
                });
            },
        },
        async mounted() {
            this.listClients(this.page, this.pageSize);

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/clients/Clients.vue